import { render, staticRenderFns } from "./RoleBadge.vue?vue&type=template&id=1b2d37cb&scoped=true&"
import script from "./RoleBadge.vue?vue&type=script&lang=js&"
export * from "./RoleBadge.vue?vue&type=script&lang=js&"
import style0 from "./RoleBadge.vue?vue&type=style&index=0&id=1b2d37cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d37cb",
  null
  
)

export default component.exports